import { CustomerSegmentController } from './customer-segment.controller'

function customerSegmentDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/directives/customer-segment/customer-segment-directive.html?$$REVISION$$',
    controller: CustomerSegmentController
  }
}

export { customerSegmentDirective }
